// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Roadmap.css */
.sageion-roadmap {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, sans-serif;
  color: #1f2937;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  min-height: 100vh;
}

/* Header */
.roadmap-header {
  text-align: center;
  margin-bottom: 3rem;
}

.roadmap-header h1 {
  font-size: 2.5rem;
  font-weight: 800;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.125rem;
  color: #6b7280;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Subscription Section */
.subscription-section {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 3rem;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
}

.subscription-card {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
}

.subscription-icon {
  font-size: 2rem;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  flex-shrink: 0;
}

.subscription-content h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 0.5rem;
}

.subscription-content p {
  color: #6b7280;
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

.subscription-form .form-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.form-input {
  flex: 1 1;
  min-width: 200px;
  padding: 0.75rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s;
}

.form-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.subscribe-button {
  padding: 0.75rem 2rem;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.subscribe-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.subscribe-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.status-message {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-weight: 500;
}

.status-message.success {
  background-color: #d1fae5;
  color: #065f46;
  border: 1px solid #a7f3d0;
}

.status-message.error {
  background-color: #fee2e2;
  color: #991b1b;
  border: 1px solid #fecaca;
}

.privacy-note {
  font-size: 0.875rem;
  color: #9ca3af;
  margin-top: 0.5rem;
}

/* Timeline Navigation */
.timeline-nav {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;
}

.timeline-tab {
  flex: 1 1;
  min-width: 120px;
  padding: 1.5rem 1rem;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.timeline-tab:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.timeline-tab.active {
  background: linear-gradient(135deg, #f8fafc 0%, #e0e7ff 100%);
  border-color: #3b82f6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.tab-quarter {
  font-size: 1.125rem;
  font-weight: 700;
  color: #1f2937;
}

.tab-status {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Quarter Content */
.quarter-content {
  background: white;
  border-radius: 16px;
  padding: 2.5rem;
  margin-bottom: 3rem;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
}

.quarter-header {
  margin-bottom: 2.5rem;
  position: relative;
}

.quarter-header h2 {
  font-size: 1.875rem;
  font-weight: 800;
  color: #1f2937;
  margin-bottom: 0.5rem;
  line-height: 1.2;
}

.quarter-subtitle {
  font-size: 1.125rem;
  color: #6b7280;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.status-badge {
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  color: white;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Features Grid */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.feature-card {
  background: #f8fafc;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #e5e7eb;
  transition: all 0.2s;
}

.feature-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.feature-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1rem;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  line-height: 1.5;
}

.feature-icon {
  color: #3b82f6;
  font-size: 1.5rem;
  line-height: 1;
  margin-top: -0.25rem;
}

/* All Quarters Preview */
.all-quarters-section {
  margin-bottom: 3rem;
}

.all-quarters-section h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1.5rem;
}

.all-quarters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.quarter-preview {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.25rem;
  cursor: pointer;
  transition: all 0.2s;
}

.quarter-preview:hover {
  border-color: #3b82f6;
  transform: translateY(-2px);
}

.quarter-preview.active-preview {
  border-color: #3b82f6;
  background: linear-gradient(135deg, #f8fafc 0%, #e0e7ff 50%);
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.preview-quarter {
  font-size: 1rem;
  font-weight: 700;
  color: #1f2937;
}

.preview-status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.preview-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
  line-height: 1.3;
}

.preview-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
}

/* Feedback CTA */
.feedback-cta {
  text-align: center;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%);
  border-radius: 16px;
  padding: 3rem 2rem;
  border: 2px solid #dbeafe;
}

.feedback-cta h3 {
  font-size: 1.875rem;
  font-weight: 800;
  color: #1f2937;
  margin-bottom: 1rem;
}

.feedback-cta p {
  font-size: 1.125rem;
  color: #6b7280;
  max-width: 600px;
  margin: 0 auto 2rem;
  line-height: 1.6;
}

.feedback-button {
  padding: 1rem 2.5rem;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.feedback-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .sageion-roadmap {
    padding: 1rem;
  }

  .roadmap-header h1 {
    font-size: 2rem;
  }

  .subscription-card {
    flex-direction: column;
  }

  .subscription-icon {
    align-self: center;
  }

  .form-row {
    flex-direction: column;
  }

  .form-input {
    min-width: 100%;
  }

  .timeline-nav {
    flex-direction: column;
  }

  .timeline-tab {
    width: 100%;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .all-quarters-grid {
    grid-template-columns: 1fr;
  }

  .quarter-content {
    padding: 1.5rem;
  }
}

/* Add these styles to your existing Roadmap.css file */

/* Feedback Section */
.feedback-section {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%);
  border-radius: 16px;
  padding: 2rem;
  border: 2px solid #dbeafe;
  transition: all 0.3s ease;
}

.feedback-section.expanded {
  padding: 2.5rem;
}

.feedback-header {
  text-align: center;
}

.feedback-header h3 {
  font-size: 1.875rem;
  font-weight: 800;
  color: #1f2937;
  margin-bottom: 1rem;
}

.feedback-header p {
  font-size: 1.125rem;
  color: #6b7280;
  max-width: 600px;
  margin: 0 auto 2rem;
  line-height: 1.6;
}

.show-feedback-button {
  padding: 1rem 2.5rem;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.show-feedback-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);
}

/* Feedback Form */
.feedback-form-container {
  margin-top: 2rem;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.feedback-form {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #374151;
}

.label-text {
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.required {
  color: #ef4444;
  margin-left: 0.25rem;
}

/* Feedback Type Options */
.feedback-type-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.feedback-type-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: #f8fafc;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  flex: 1 1;
  min-width: 120px;
}

.feedback-type-option:hover {
  border-color: #3b82f6;
  background: #f0f9ff;
}

.type-radio {
  display: none;
}

.type-radio:checked + .type-emoji + .type-label {
  font-weight: 700;
}

.type-radio:checked + .type-emoji {
  transform: scale(1.2);
}

.feedback-type-option.active {
  border-color: #3b82f6;
  background: #f0f9ff;
}

.type-emoji {
  font-size: 1.25rem;
  transition: transform 0.2s;
}

.type-label {
  font-size: 0.875rem;
  color: #374151;
}

/* Textarea */
.form-textarea {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
  transition: all 0.2s;
}

.form-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.character-count {
  text-align: right;
  font-size: 0.75rem;
  color: #9ca3af;
  margin-top: 0.25rem;
}

/* Tags */
.tags-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.predefined-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.tag {
  padding: 0.5rem 1rem;
  background: #f8fafc;
  border: 2px solid #e5e7eb;
  border-radius: 9999px;
  font-size: 0.875rem;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;
}

.tag:hover {
  border-color: #3b82f6;
  color: #3b82f6;
}

.tag.selected {
  background: #3b82f6;
  border-color: #3b82f6;
  color: white;
}

.custom-tag-input {
  display: flex;
  gap: 0.5rem;
}

.tag-input {
  flex: 1 1;
  padding: 0.5rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 0.875rem;
}

.add-tag-button {
  padding: 0.5rem 1rem;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.add-tag-button:hover {
  background: #059669;
}

.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.selected-tags-label {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 600;
}

.selected-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
  background: #dbeafe;
  color: #1e40af;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
}

.remove-tag {
  background: none;
  border: none;
  color: #1e40af;
  font-size: 1.25rem;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  margin-left: 0.25rem;
}

.remove-tag:hover {
  color: #1e3a8a;
}

/* Form Actions */
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.cancel-button {
  padding: 0.75rem 2rem;
  background: #f8fafc;
  color: #6b7280;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-button:hover {
  background: #f1f5f9;
  border-color: #d1d5db;
}

.submit-feedback-button {
  padding: 0.75rem 2rem;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.submit-feedback-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
}

.submit-feedback-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Feedback Status */
.feedback-status {
  margin-top: 1.5rem;
  padding: 1rem;
  border-radius: 8px;
  font-weight: 500;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.feedback-status.success {
  background-color: #d1fae5;
  color: #065f46;
  border: 1px solid #a7f3d0;
}

.feedback-status.error {
  background-color: #fee2e2;
  color: #991b1b;
  border: 1px solid #fecaca;
}

/* Responsive Design Updates */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }

  .feedback-type-options {
    flex-direction: column;
  }

  .feedback-type-option {
    min-width: 100%;
  }

  .form-actions {
    flex-direction: column;
  }

  .cancel-button,
  .submit-feedback-button {
    width: 100%;
  }

  .feedback-section {
    padding: 1.5rem;
  }

  .feedback-section.expanded {
    padding: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/roadmap/Roadmap.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb;;qBAEmB;EACnB,cAAc;EACd,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB;;sCAEoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB;;sCAEoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,uDAAuD;;AAEvD,qBAAqB;AACrB;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Roadmap.css */\n.sageion-roadmap {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\",\n    Arial, sans-serif;\n  color: #1f2937;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  min-height: 100vh;\n}\n\n/* Header */\n.roadmap-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.roadmap-header h1 {\n  font-size: 2.5rem;\n  font-weight: 800;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-bottom: 1rem;\n}\n\n.subtitle {\n  font-size: 1.125rem;\n  color: #6b7280;\n  max-width: 800px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n/* Subscription Section */\n.subscription-section {\n  background: white;\n  border-radius: 16px;\n  padding: 2rem;\n  margin-bottom: 3rem;\n  box-shadow:\n    0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  border: 1px solid #e5e7eb;\n}\n\n.subscription-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 1.5rem;\n}\n\n.subscription-icon {\n  font-size: 2rem;\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  flex-shrink: 0;\n}\n\n.subscription-content h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 0.5rem;\n}\n\n.subscription-content p {\n  color: #6b7280;\n  margin-bottom: 1.5rem;\n  line-height: 1.5;\n}\n\n.subscription-form .form-row {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.form-input {\n  flex: 1;\n  min-width: 200px;\n  padding: 0.75rem 1rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.2s;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.subscribe-button {\n  padding: 0.75rem 2rem;\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.subscribe-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);\n}\n\n.subscribe-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.status-message {\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  font-weight: 500;\n}\n\n.status-message.success {\n  background-color: #d1fae5;\n  color: #065f46;\n  border: 1px solid #a7f3d0;\n}\n\n.status-message.error {\n  background-color: #fee2e2;\n  color: #991b1b;\n  border: 1px solid #fecaca;\n}\n\n.privacy-note {\n  font-size: 0.875rem;\n  color: #9ca3af;\n  margin-top: 0.5rem;\n}\n\n/* Timeline Navigation */\n.timeline-nav {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 3rem;\n  flex-wrap: wrap;\n}\n\n.timeline-tab {\n  flex: 1;\n  min-width: 120px;\n  padding: 1.5rem 1rem;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.timeline-tab:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.timeline-tab.active {\n  background: linear-gradient(135deg, #f8fafc 0%, #e0e7ff 100%);\n  border-color: #3b82f6;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);\n}\n\n.tab-quarter {\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.tab-status {\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* Quarter Content */\n.quarter-content {\n  background: white;\n  border-radius: 16px;\n  padding: 2.5rem;\n  margin-bottom: 3rem;\n  box-shadow:\n    0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  border: 1px solid #e5e7eb;\n}\n\n.quarter-header {\n  margin-bottom: 2.5rem;\n  position: relative;\n}\n\n.quarter-header h2 {\n  font-size: 1.875rem;\n  font-weight: 800;\n  color: #1f2937;\n  margin-bottom: 0.5rem;\n  line-height: 1.2;\n}\n\n.quarter-subtitle {\n  font-size: 1.125rem;\n  color: #6b7280;\n  margin-bottom: 1rem;\n  line-height: 1.5;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 0.5rem 1rem;\n  border-radius: 9999px;\n  color: white;\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* Features Grid */\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.feature-card {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid #e5e7eb;\n  transition: all 0.2s;\n}\n\n.feature-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.feature-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 1rem;\n}\n\n.feature-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.feature-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n  line-height: 1.5;\n}\n\n.feature-icon {\n  color: #3b82f6;\n  font-size: 1.5rem;\n  line-height: 1;\n  margin-top: -0.25rem;\n}\n\n/* All Quarters Preview */\n.all-quarters-section {\n  margin-bottom: 3rem;\n}\n\n.all-quarters-section h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 1.5rem;\n}\n\n.all-quarters-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.quarter-preview {\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 1.25rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.quarter-preview:hover {\n  border-color: #3b82f6;\n  transform: translateY(-2px);\n}\n\n.quarter-preview.active-preview {\n  border-color: #3b82f6;\n  background: linear-gradient(135deg, #f8fafc 0%, #e0e7ff 50%);\n}\n\n.preview-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.preview-quarter {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.preview-status-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.preview-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0.5rem;\n  line-height: 1.3;\n}\n\n.preview-subtitle {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n/* Feedback CTA */\n.feedback-cta {\n  text-align: center;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%);\n  border-radius: 16px;\n  padding: 3rem 2rem;\n  border: 2px solid #dbeafe;\n}\n\n.feedback-cta h3 {\n  font-size: 1.875rem;\n  font-weight: 800;\n  color: #1f2937;\n  margin-bottom: 1rem;\n}\n\n.feedback-cta p {\n  font-size: 1.125rem;\n  color: #6b7280;\n  max-width: 600px;\n  margin: 0 auto 2rem;\n  line-height: 1.6;\n}\n\n.feedback-button {\n  padding: 1rem 2.5rem;\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 1.125rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.feedback-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .sageion-roadmap {\n    padding: 1rem;\n  }\n\n  .roadmap-header h1 {\n    font-size: 2rem;\n  }\n\n  .subscription-card {\n    flex-direction: column;\n  }\n\n  .subscription-icon {\n    align-self: center;\n  }\n\n  .form-row {\n    flex-direction: column;\n  }\n\n  .form-input {\n    min-width: 100%;\n  }\n\n  .timeline-nav {\n    flex-direction: column;\n  }\n\n  .timeline-tab {\n    width: 100%;\n  }\n\n  .features-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .all-quarters-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .quarter-content {\n    padding: 1.5rem;\n  }\n}\n\n/* Add these styles to your existing Roadmap.css file */\n\n/* Feedback Section */\n.feedback-section {\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%);\n  border-radius: 16px;\n  padding: 2rem;\n  border: 2px solid #dbeafe;\n  transition: all 0.3s ease;\n}\n\n.feedback-section.expanded {\n  padding: 2.5rem;\n}\n\n.feedback-header {\n  text-align: center;\n}\n\n.feedback-header h3 {\n  font-size: 1.875rem;\n  font-weight: 800;\n  color: #1f2937;\n  margin-bottom: 1rem;\n}\n\n.feedback-header p {\n  font-size: 1.125rem;\n  color: #6b7280;\n  max-width: 600px;\n  margin: 0 auto 2rem;\n  line-height: 1.6;\n}\n\n.show-feedback-button {\n  padding: 1rem 2.5rem;\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 1.125rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.show-feedback-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);\n}\n\n/* Feedback Form */\n.feedback-form-container {\n  margin-top: 2rem;\n  animation: slideDown 0.3s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.feedback-form {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.label-text {\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.required {\n  color: #ef4444;\n  margin-left: 0.25rem;\n}\n\n/* Feedback Type Options */\n.feedback-type-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.feedback-type-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: #f8fafc;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  flex: 1;\n  min-width: 120px;\n}\n\n.feedback-type-option:hover {\n  border-color: #3b82f6;\n  background: #f0f9ff;\n}\n\n.type-radio {\n  display: none;\n}\n\n.type-radio:checked + .type-emoji + .type-label {\n  font-weight: 700;\n}\n\n.type-radio:checked + .type-emoji {\n  transform: scale(1.2);\n}\n\n.feedback-type-option.active {\n  border-color: #3b82f6;\n  background: #f0f9ff;\n}\n\n.type-emoji {\n  font-size: 1.25rem;\n  transition: transform 0.2s;\n}\n\n.type-label {\n  font-size: 0.875rem;\n  color: #374151;\n}\n\n/* Textarea */\n.form-textarea {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-family: inherit;\n  resize: vertical;\n  transition: all 0.2s;\n}\n\n.form-textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.character-count {\n  text-align: right;\n  font-size: 0.75rem;\n  color: #9ca3af;\n  margin-top: 0.25rem;\n}\n\n/* Tags */\n.tags-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.predefined-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.tag {\n  padding: 0.5rem 1rem;\n  background: #f8fafc;\n  border: 2px solid #e5e7eb;\n  border-radius: 9999px;\n  font-size: 0.875rem;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.tag:hover {\n  border-color: #3b82f6;\n  color: #3b82f6;\n}\n\n.tag.selected {\n  background: #3b82f6;\n  border-color: #3b82f6;\n  color: white;\n}\n\n.custom-tag-input {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.tag-input {\n  flex: 1;\n  padding: 0.5rem 1rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 0.875rem;\n}\n\n.add-tag-button {\n  padding: 0.5rem 1rem;\n  background: #10b981;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.add-tag-button:hover {\n  background: #059669;\n}\n\n.selected-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.selected-tags-label {\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-weight: 600;\n}\n\n.selected-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.75rem;\n  background: #dbeafe;\n  color: #1e40af;\n  border-radius: 9999px;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.remove-tag {\n  background: none;\n  border: none;\n  color: #1e40af;\n  font-size: 1.25rem;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n  margin-left: 0.25rem;\n}\n\n.remove-tag:hover {\n  color: #1e3a8a;\n}\n\n/* Form Actions */\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.cancel-button {\n  padding: 0.75rem 2rem;\n  background: #f8fafc;\n  color: #6b7280;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cancel-button:hover {\n  background: #f1f5f9;\n  border-color: #d1d5db;\n}\n\n.submit-feedback-button {\n  padding: 0.75rem 2rem;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.submit-feedback-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);\n}\n\n.submit-feedback-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Feedback Status */\n.feedback-status {\n  margin-top: 1.5rem;\n  padding: 1rem;\n  border-radius: 8px;\n  font-weight: 500;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.feedback-status.success {\n  background-color: #d1fae5;\n  color: #065f46;\n  border: 1px solid #a7f3d0;\n}\n\n.feedback-status.error {\n  background-color: #fee2e2;\n  color: #991b1b;\n  border: 1px solid #fecaca;\n}\n\n/* Responsive Design Updates */\n@media (max-width: 768px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .feedback-type-options {\n    flex-direction: column;\n  }\n\n  .feedback-type-option {\n    min-width: 100%;\n  }\n\n  .form-actions {\n    flex-direction: column;\n  }\n\n  .cancel-button,\n  .submit-feedback-button {\n    width: 100%;\n  }\n\n  .feedback-section {\n    padding: 1.5rem;\n  }\n\n  .feedback-section.expanded {\n    padding: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
